const REST_API_SHS_SPRINT =
  globals.NODE_ENV === 'production'
    ? {
        URL: {
          v1Testimonials:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/testimonials',
          submitClaim: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/claimstool',
          validateStore: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/validatestore',
          retrieveStoreStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/storestats',
          retrieveUserStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/userstats',
          dashboardStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/dashboardstats',
          listAllAppointments: '',
          editAppointment: '',
          cancelAppointment: '',
          createAppointment:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/insertCustomerData',
          usedAppointmentTimeSlots:
            'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/timestamp',
          csdb: 'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/csdbproxy',
          vhtAddAppointment:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/updatevht',
          vhtGetNextAvailableAppointmentTime:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/fetchtimeslotsfromvht',
          experiencesVhtGetNextAvailableAppointmentTime:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/fetchtimeslotsfromvht',
          sendV1IdAndVhtId:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/updateCustomerData',
          feedback: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/feedback',
          reporting:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/sendreportingevents',
          getAppointment: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbyid',
          getAtlasId:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/getUniversalId',
          retrieveQuotesAndTips: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/quotes',
          getCustomerByMdn: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbymdn',
          survey: 'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/suggesttopic',
          joinResearch: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/joinresearch',
          decrypt: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/decrypt',
          fonoApiUrl: 'https://fonoapi.freshpixl.com/v1/getdevice',
          leaderBoard: 'https://53020nhmrc.execute-api.us-east-1.amazonaws.com/v1/leaderboard',
          campaignDetails:
            'https://f65v6lll19.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/notificationdetails?id=',
          expertSessionsAppointment:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/getappointmentinfo',
          expertSessionsFeedback:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/insertSurveyResponse',
          expertSessionsJoinResearch:
            'https://q0d3y7z8ka.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/insertFeedbackEmails',
          unsubscribe: 'https://f65v6lll19.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/unsubscribe',
        },
        KEY: {
          recaptcha: '6LcB16oUAAAAAPL-fHYbWisA-tqBI63cyrAHZx0W',
          mixpanelApiKey: 'P3VCb09P7Q4H453Xg0DVMNKa5t4F8ErhFKHa0b2g',
          mixpanelSource: 'shs-experiences',
          carrier: 'sprint',
          scope: 'SHS_EXPERT_SESSIONS',
        },
        VHTSEGMENT: {
          mysheduleSegment: {
            key: 'ATT.en-us.Soluto_Mega1.',
            value: 'ATT_MPC',
          },
        },
      }
    : {
        URL: {
          v1Testimonials:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/testimonials',
          submitClaim: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/claimstool',
          validateStore: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/validatestore',
          retrieveStoreStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/storestats',
          retrieveUserStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/userstats',
          dashboardStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/dashboardstats',
          listAllAppointments: '',
          editAppointment: '',
          cancelAppointment: '',
          createAppointment:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/insertCustomerData',
          usedAppointmentTimeSlots:
            'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/timestamp',
          csdb: 'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/csdbproxy',
          vhtAddAppointment:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/updatevht',
          vhtGetNextAvailableAppointmentTime:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/fetchtimeslotsfromvht',
          experiencesVhtGetNextAvailableAppointmentTime:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/fetchtimeslotsfromvht',
          sendV1IdAndVhtId:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/updateCustomerData',
          feedback: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/feedback',
          reporting:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/sendreportingevents',
          getAppointment: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbyid',
          getAtlasId:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/getUniversalId',
          retrieveQuotesAndTips: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/quotes',
          getCustomerByMdn: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbymdn',
          survey: 'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/suggesttopic',
          joinResearch: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/joinresearch',
          decrypt: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/decrypt',
          fonoApiUrl: 'https://fonoapi.freshpixl.com/v1/getdevice',
          leaderBoard: 'https://53020nhmrc.execute-api.us-east-1.amazonaws.com/v1/leaderboard',
          campaignDetails:
            'https://u8hgm6aw99.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/notificationdetails?id=',
          expertSessionsAppointment:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/getappointmentinfo',
          expertSessionsFeedback:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/insertSurveyResponse',
          expertSessionsJoinResearch:
            'https://c7y04qabk6.execute-api.us-east-1.amazonaws.com/ccapp-experiences-sprint/v3/insertFeedbackEmails',
          unsubscribe: ' https://u8hgm6aw99.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/unsubscribe',
        },
        KEY: {
          recaptcha: '6LcB16oUAAAAAPL-fHYbWisA-tqBI63cyrAHZx0W',
          mixpanelApiKey: 'P3VCb09P7Q4H453Xg0DVMNKa5t4F8ErhFKHa0b2g',
          mixpanelSource: 'shs-experiences',
          carrier: 'sprint',
          scope: 'SHS_EXPERT_SESSIONSQA',
        },
        VHTSEGMENT: {
          mysheduleSegment: {
            key: 'ATT.en-us.Soluto_Mega1.',
            value: 'ATT_MPC',
          },
        },
      };

export default REST_API_SHS_SPRINT;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/config/restApi.SHS-SPRINT.js